import { useQueryClient } from "@tanstack/react-query"
import { useEffect } from "react"
import { useSelector } from "react-redux"

import api from "apis"

export const usePrefetchPages = () => {
  const queryClient = useQueryClient()
  const pagesToPrefetch = useSelector(
    (state) => state.sale.prefetch_pages || []
  )
  const homepageExp = useSelector(
    (state) => state.experiment.homepage.variant_id
  )

  useEffect(() => {
    const prefetchPages = () =>
      [
        homepageExp === 1 ? "homepage-b" : "homepage",
        ...pagesToPrefetch,
      ].forEach((url_path) =>
        queryClient.prefetchInfiniteQuery({
          queryFn: () =>
            api.fetch(
              `/api/v10/collections/${url_path}/load_react_collection?prefetch=1`,
              { priority: "low" }
            ),
          queryKey: [url_path],
        })
      )

    const rIC = window.requestIdleCallback || ((cb) => setTimeout(cb, 1))
    const cIC = window.cancelIdleCallback || clearTimeout

    const idleHandle = rIC(() => prefetchPages())

    return () => cIC(idleHandle)
  }, [queryClient, pagesToPrefetch])
}

export default usePrefetchPages
